angular.module('shared').factory('bulkMessageService', ["$rootScope", "$state", "$http", "$q", "Restangular", "TemplateSanitizeService", function($rootScope, $state, $http, $q, Restangular, TemplateSanitizeService) {
  var buildRecipient, buildRecipientList, bulkMessage, bulkMessageService, createContactRecipientsList, groupRecipients, gymId, loadContactCommsRecipients, ref, resource;
  bulkMessage = {
    recipientList: [],
    recipients: [],
    groupedRecipients: [],
    template: {}
  };
  gymId = $rootScope.toParams ? (ref = $rootScope.toParams) != null ? ref.gymId : void 0 : $state.params.gymId;
  resource = Restangular.one('gyms', gymId).all('bulk_messages');
  bulkMessageService = {
    get: function() {
      return bulkMessage;
    },
    set: function(message) {
      var deferred;
      deferred = $q.defer();
      bulkMessage = message;
      buildRecipientList(bulkMessage.recipients).then(function(result) {
        bulkMessage.recipientList = result.recipientList;
        bulkMessage.groupedRecipients = result.groupedRecipients;
        return deferred.resolve(bulkMessage);
      });
      return deferred.promise;
    },
    clear: function() {
      return bulkMessage = {
        recipientList: [],
        recipients: [],
        groupedRecipients: [],
        template: {}
      };
    },
    create: function(bulkMessage, params) {
      var contact_ids, message, template;
      template = TemplateSanitizeService.sanitize(bulkMessage.template);
      contact_ids = _.chain(bulkMessage.recipientList).filter(function(recipient) {
        return recipient.selected;
      }).map(function(recipient) {
        return recipient.id;
      }).value();
      if (params.event_id) {
        template.event_id = params.event_id;
      }
      if (params.invoice_id) {
        template.invoice_id = params.invoice_id;
      }
      message = {
        withoutNamespace: true,
        bulk_message: {
          contact_comms_recipient_ids: contact_ids,
          report_ids: bulkMessage.reportIds,
          template_options: template,
          source: params.source
        }
      };
      this.clear();
      return resource.post(message);
    },
    setRecipients: function(recipients, params) {
      return bulkMessage.recipients = recipients.map(function(recipient) {
        recipient.key = recipient.id;
        return recipient;
      });
    },
    getDuplicatesGroups: function(recipients, params) {
      var grouped, key, keyMap, ref1, selected;
      if ((ref1 = params.type) !== 'email' && ref1 !== 'sms') {
        return [];
      }
      keyMap = {
        email: 'email',
        sms: 'phone_number'
      };
      key = keyMap[params.type];
      selected = recipients.map(function(item) {
        return angular.extend({}, item);
      }).filter(function(recipient) {
        return params.includeDeselected || recipient.selected;
      });
      grouped = _.groupBy(selected, key);
      return _.filter(grouped, function(group) {
        return group.length > 1;
      });
    },
    getDuplicateCount: function(recipients, type) {
      var duplicates, withDuplicates;
      withDuplicates = this.getDuplicatesGroups(recipients, {
        type: type
      });
      duplicates = _.flatten(withDuplicates);
      return duplicates != null ? duplicates.length : void 0;
    },
    syncDuplicates: function(groups) {
      var items, syncItem;
      items = _.chain(groups).flatten().indexBy('id').value();
      syncItem = function(item) {
        if (items[item.id]) {
          return item.selected = items[item.id].selected;
        }
      };
      bulkMessage.recipientList.forEach(function(item) {
        return syncItem(item);
      });
      return bulkMessage.groupedRecipients.forEach(function(item) {
        var ref1;
        syncItem(item);
        if ((ref1 = item.secondary) != null ? ref1.length : void 0) {
          return item.secondary.forEach(function(secondary) {
            return syncItem(secondary);
          });
        }
      });
    },
    pluralMessageType: function(channel, recipients) {
      var count;
      count = _.filter(recipients, function(item) {
        return item.selected;
      }).length;
      switch (channel) {
        case 'email':
          if (count === 1) {
            return 'Email';
          } else {
            return 'Emails';
          }
          break;
        case 'sms':
          if (count === 1) {
            return 'SMS';
          } else {
            return 'SMSes';
          }
          break;
        case 'push_notification':
          if (count === 1) {
            return 'Push notification';
          } else {
            return 'Push notifications';
          }
      }
    }
  };
  buildRecipientList = function(recipients) {
    var recipientList;
    recipientList = [];
    recipients.forEach(function(recipient) {
      return recipientList.push(recipient);
    });
    return createContactRecipientsList(recipientList);
  };
  buildRecipient = function(recipient, channel) {
    recipient.primary_contact_id = recipient.contact_id;
    if (bulkMessage.template.channel === 'push_notification') {
      recipient.for_primary_contact = true;
    }
    recipient.name = recipient.for_primary_contact ? recipient.contact_name : recipient.name || recipient.family_member_name;
    recipient.type = recipient.for_primary_contact ? recipient.contact_type : recipient.family_member_type;
    recipient.status = recipient.status || recipient.contact_status;
    recipient.contact_id = recipient.for_primary_contact ? recipient.contact_id : recipient.family_member_id;
    recipient.email = recipient.for_primary_contact ? recipient.contact_email : recipient.recipient_email;
    recipient.phone_number = recipient.for_primary_contact ? recipient.contact_phone_number : recipient.recipient_phone_number;
    recipient.unsubscribed_from_email = recipient.email_status === 'email_unsubscribed';
    recipient.unsubscribed_from_sms = recipient.sms_status === 'sms_unsubscribed';
    recipient.selected = (function() {
      switch (channel) {
        case 'sms':
          return recipient.sms_status === 'sms_accepted' && !recipient.unsubscribed_from_sms && !!recipient.phone_number;
        case 'email':
          return recipient.email_status === 'email_accepted' && !recipient.unsubscribed_from_email && !!recipient.email;
        case 'push_notification':
          return recipient.push_notification_status === 'notifiable';
      }
    })();
    return recipient;
  };
  loadContactCommsRecipients = function(contacts) {
    var channel, contactCommsRecipientIds, deferred, gym, ids, params, recipientLimit, ref1, url;
    gym = $rootScope.gym || window.DATA;
    recipientLimit = gym.gym_config.bulk_comms_recipient_limit;
    deferred = $q.defer();
    url = bulkMessage.template.channel === 'push_notification' ? `/gyms/${gymId}/mobile_app/push_notification_recipients/list` : `/gyms/${gymId}/contact_comms_recipients/list`;
    bulkMessage.reportIds = _.uniq(contacts).filter(function(item) {
      return item.route === 'reports';
    }).map(function(item) {
      return item.id;
    });
    contactCommsRecipientIds = ((ref1 = contacts.find(function(item) {
      return item.route === 'bulk_message';
    })) != null ? ref1.recipient_ids : void 0) || [];
    ids = _.uniq(contacts).filter(function(item) {
      var ref2;
      return ((ref2 = item.route) !== 'reports' && ref2 !== 'bulk_message') && (item.for_primary_contact || item.for_primary_contact === void 0);
    }).map(function(item) {
      return item.contact_id || item.id;
    });
    channel = bulkMessage.template.channel;
    params = {
      filters: {
        contact_ids: ids,
        report_ids: bulkMessage.reportIds,
        contact_comms_recipient_ids: contactCommsRecipientIds
      },
      count: recipientLimit
    };
    $http.post(url, params).then(function(response) {
      var recipients;
      recipients = _.uniq(response.data.collection, false, function(item) {
        return item.id;
      }).map(function(recipient) {
        return buildRecipient(recipient, channel);
      });
      return deferred.resolve(recipients);
    });
    return deferred.promise;
  };
  groupRecipients = function(recipients) {
    var gg, groups;
    groups = _.values(_.groupBy(recipients, function(item) {
      return item.primary_contact_id;
    }));
    return gg = groups.map(function(contactRecipients) {
      var group, recipient;
      group = _.groupBy(contactRecipients, function(item) {
        if (item.for_primary_contact) {
          return 'primary';
        } else {
          return 'secondary';
        }
      });
      recipient = group.primary[0];
      recipient.secondary = group.secondary;
      return recipient;
    });
  };
  createContactRecipientsList = function(recipients) {
    var deferred;
    deferred = $q.defer();
    loadContactCommsRecipients(recipients).then(function(recipients) {
      return deferred.resolve({
        recipientList: recipients,
        groupedRecipients: groupRecipients(recipients)
      });
    });
    return deferred.promise;
  };
  return bulkMessageService;
}]);
